import "./Products.module.css";
import NavigationPortal from "@/reusable_sections/Header";
import OurSmartHardwareCatalog from "./sections/OurSmartHardwareCatalog";
import VisualGallery from "./sections/VisualGallery";
import Footer from "@/reusable_sections/Footer";
export default function ProductsPage() {
  return <div>
      <NavigationPortal />
      <OurSmartHardwareCatalog />
      <VisualGallery />
      <Footer />
    </div>;
}